import { useState, useEffect } from "react";
import { settingsApi } from "@rshbintech.dboul/http";
import { logger } from "@rshbintech.dboul/logger";
import { ClientSettingsContext } from "../client-settings-context";
import { ClientSettingsType } from "../types";
import { ClientSettingsProviderProps } from "./types";

export const ClientSettingsProvider = ({
  children,
}: ClientSettingsProviderProps) => {
  const [clientSettings, setClientSettings] =
    useState<ClientSettingsType>(null);

  const [isClientSettingsLoading, setIsClientSettingsLoading] = useState(true);

  const getClientSettings = async () => {
    setIsClientSettingsLoading(true);
    try {
      const clientSettingsResponse =
        await settingsApi.api.getClientExternalSettings({
          propertyTypeSignatures: ["web"],
        });

      setClientSettings(clientSettingsResponse.data);
    } catch (error) {
      logger.sendError(error);
    } finally {
      setIsClientSettingsLoading(false);
    }
  };

  useEffect(() => {
    getClientSettings();
  }, []);

  return (
    <ClientSettingsContext.Provider
      value={{
        clientSettings,
        isClientSettingsLoading,
      }}
    >
      {children}
    </ClientSettingsContext.Provider>
  );
};
